import { useContext } from 'react';

import { recalculate } from '~/src/features/tariffBuilder/actions/thunk';
import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { Ctx, TCtxDispatch } from '~/src/features/tariffBuilder/Ctx';
import { TAction } from '~/src/features/tariffBuilder/reducer';

const forRecalculate = [
    EAction.SelectSpeed,
    EAction.AddEntity,
    EAction.AddTvEntity,
    EAction.IncrementEntity,
    EAction.DecrementEntity,
    EAction.RemoveEntity,
    EAction.RemoveTvEntity,
    EAction.RemoveAllTvEntities,
    EAction.SetSpeedRestrictions,
];

const useCtxDispatch = (): TCtxDispatch => {
    const { dispatch, debugMode, toaster } = useContext(Ctx);

    return (action: TAction) => {
        debugMode && console.table(action);
        dispatch(action);

        if (forRecalculate.includes(action.type)) {
            dispatch(recalculate(toaster));
        }
    };
};


export default useCtxDispatch;
